import { createSelector } from '@reduxjs/toolkit';
import { getTournamentTimezone } from '../../pages/tourDetails/Schedule/components/schedule.helpers';
import {
  detectScheduleConflicts,
  getScheduleConflictMatchIds,
} from './scheduleConflictDetector';
import {
  selectScheduleClassIdToObject,
  selectScheduleConstraints,
  selectScheduleData,
  selectScheduleTournamentInfo,
} from './scheduleSelectors';

export const selectScheduleConflicts = createSelector(
  [
    selectScheduleData,
    selectScheduleConstraints,
    selectScheduleTournamentInfo,
    selectScheduleClassIdToObject,
  ],
  (schedule, constraints, tournamentInfo, classIdToObject) => {
    const timeZone = getTournamentTimezone(
      tournamentInfo?.country,
      tournamentInfo?.timeZone
    );
    return detectScheduleConflicts(
      schedule,
      constraints,
      timeZone,
      classIdToObject
    );
  }
);

export const selectScheduleConflictCount = createSelector(
  [selectScheduleConflicts],
  (conflicts) => conflicts.length
);

export const selectScheduleConflictMatchIds = createSelector(
  [selectScheduleConflicts],
  (conflicts) => getScheduleConflictMatchIds(conflicts)
);

/** Stable sorted list for React memo comparisons (Set identity changes each run). */
export const selectScheduleConflictMatchIdList = createSelector(
  [selectScheduleConflicts],
  (conflicts) => [...getScheduleConflictMatchIds(conflicts)].sort((a, b) => a - b)
);
